export var ErrorMessages = {
  "en-US": {
    E0000001: "There was an error trying to process your request. Please try again.",
    E0000004: "There was an error trying to process your request. Please try again.",
    // authentication failure
    E0000009: "There was an error trying to process your request. Please try again.",
    // timeout
    "-1000": "There was an error trying to process your request. Please try again.",
    "-2000": "An account has already been created with that email address. If that account belongs to you, please log in to access your account or update your information and preferences.",
    DUPLICATE_CREDS: "An account has already been created with that email address. If that account belongs to you, please log in to access your account or update your information and preferences.",
    // sub of E0000001
    UNKNOWN_ERROR: "There was an error trying to process your request. Please try again.",
    INVALID_CREDS: "There was an error trying to process your request. Please try again.",
    // authentication failure
    COPPA: "You are ineligible to complete registration.",
    AGREE_TOS: "To register, you must agree to the Terms of Use and Privacy Policy.",
    EMAIL: "Please provide a valid email.",
    TIEBREAKERS: "Please answer all required questions *",
    PASSWORD: "Please provide a valid password.",
    CONFIRM_PASSWORD: "Please confirm your password.",
    DOB: "Please provide a valid date of birth.",
    MONTH: "Please provide a valid month",
    DAY: "Please provide a valid day.",
    YEAR: "Please provide a valid year.",
    MOBILE_PHONE: "Please provide a valid phone number."
  },
  "es-US": {
    E0000001: "Hubo un error al intentar procesar su solicitud. Vuelva a intentarlo.",
    E0000004: "Hubo un error al intentar procesar su solicitud. Vuelva a intentarlo.",
    // authentication failure
    E0000009: "Hubo un error al intentar procesar su solicitud. Vuelva a intentarlo.",
    // timeout
    "-1000": "Hubo un error al intentar procesar su solicitud. Vuelva a intentarlo.",
    "-2000": "Ya se ha creado una cuenta con ese correo electrónico. Si esa cuenta le pertenece, inicie sesión para acceder a su cuenta o actualizar su información y preferencias",
    DUPLICATE_CREDS: "Ya se ha creado una cuenta con ese correo electrónico. Si esa cuenta le pertenece, inicie sesión para acceder a su cuenta o actualizar su información y preferencias",
    // sub of E0000001
    UNKNOWN_ERROR: "Hubo un error al intentar procesar su solicitud. Vuelva a intentarlo.",
    INVALID_CREDS: "Hubo un error al intentar procesar su solicitud. Vuelva a intentarlo.",
    // authentication failure
    COPPA: "No eres elegible para completar el registro.",
    AGREE_TOS: "Para registrarse, debe aceptar los Términos de Uso y Política de Privacidad.",
    EMAIL: "Proporcione un correo electrónico válido",
    TIEBREAKERS: "Responda todas las preguntas obligatorias *",
    PASSWORD: "Proporcione una contraseña válida",
    CONFIRM_PASSWORD: "Confirme su contraseña.",
    DOB: "Indique una fecha de nacimiento válida.",
    MONTH: "Indique un mes válido",
    DAY: "Indique un día válido.",
    YEAR: "Indique un año válido.",
    MOBILE_PHONE: "Proporcione un número de teléfono válido."
  }
};
export var formatErrorMessage = function formatErrorMessage(error, locale) {
  var _error$response, _responseData$errorCa, _responseData$errorCa2;
  if (!error) {
    return "";
  }
  var responseData = (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) || {};
  var errorKey = responseData.errorCode || error.errorName || "";
  var errorMessage = responseData.message || "";
  var errorSummary = (responseData === null || responseData === void 0 ? void 0 : (_responseData$errorCa = responseData.errorCauses) === null || _responseData$errorCa === void 0 ? void 0 : (_responseData$errorCa2 = _responseData$errorCa[0]) === null || _responseData$errorCa2 === void 0 ? void 0 : _responseData$errorCa2.errorSummary) || "";
  var message = ErrorMessages[locale][errorKey];
  if (errorSummary.indexOf("duplicate email address") > -1) {
    return ErrorMessages[locale].DUPLICATE_CREDS;
  }
  if (message) {
    return message;
  }
  if (errorMessage.indexOf("Invalid credentials") > -1) {
    return ErrorMessages[locale].INVALID_CREDS;
  }
  return ErrorMessages[locale].UNKNOWN_ERROR;
};